// Copyright (c) 2021 Deere & Company

import LaborRate from '@deere/cps-it.warranty-model-factory/lib/labor-rate';
import t from 'tcomb';

const MassLaborRateRequestStatusDetails = t.list(LaborRate);

export const getDefaultState = () => new MassLaborRateRequestStatusDetails([]);

export default MassLaborRateRequestStatusDetails;




// WEBPACK FOOTER //
// ./src/claim/mass-labor-rate-request-status-details/state/mass-labor-rates-request-details.js